import service from '../../http/axios';

//  获取AI结果列表
export const getList = service({
  url: '/yinghe-api/viewer/getAiList',
});

export const confirmAiResult = service({
  method: 'POST',
  url: '/yinghe-api/viewer/confirmAiResult',
});

export const saveAiCheck = service({
  method: 'POST',
  url: '/yinghe-api/viewer/saveAiCheck',
});

export const saveAiCheckedItem = service({
  method: 'POST',
  url: '/yinghe-api/viewer/saveAiCheckedItem',
});

// 条件查询 获取AI分析结果
export const getAiResultSearchByI2d = service({
  url: '/yinghe-api/viewer/getAiResultSearchById',
});

export const getAnalysisResultLis2t = service({
  method: 'POST',
  url: '/yinghe-api/viewer/getAiResultById',
});
